/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Records_EmptyInputs */

const en_us2_progress_report_records_empty = /** @type {(inputs: Progress_Report_Records_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`No records this week.`);
	return /** @type {LocalizedString} */ (`No records this month.`)
	
};

const pt_br2_progress_report_records_empty = /** @type {(inputs: Progress_Report_Records_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nenhum recorde nesta semana.`);
	return /** @type {LocalizedString} */ (`Nenhum recorde neste mês.`)
	
};

const es_419_progress_report_records_empty = /** @type {(inputs: Progress_Report_Records_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Ningún récord esta semana.`);
	return /** @type {LocalizedString} */ (`Ningún récord este mes.`)
	
};

const pt_pt2_progress_report_records_empty = /** @type {(inputs: Progress_Report_Records_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nenhum recorde nesta semana.`);
	return /** @type {LocalizedString} */ (`Nenhum recorde neste mês.`)
	
};

const fr_fr2_progress_report_records_empty = /** @type {(inputs: Progress_Report_Records_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Aucun record cette semaine.`);
	return /** @type {LocalizedString} */ (`Aucun record ce mois-ci.`)
	
};

const de_de2_progress_report_records_empty = /** @type {(inputs: Progress_Report_Records_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Keine Rekorde diese Woche.`);
	return /** @type {LocalizedString} */ (`Keine Rekorde diesen Monat.`)
	
};

const it_it2_progress_report_records_empty = /** @type {(inputs: Progress_Report_Records_EmptyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Nessun record questa settimana.`);
	return /** @type {LocalizedString} */ (`Nessun record questo mese.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "No records this week." |
* | * | "No records this month." |
*
* @param {Progress_Report_Records_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_records_empty = /** @type {((inputs: Progress_Report_Records_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Records_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_records_empty(inputs)
	if (locale === "es-419") return es_419_progress_report_records_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_records_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_records_empty(inputs)
	if (locale === "de-DE") return de_de2_progress_report_records_empty(inputs)
	if (locale === "it-IT") return it_it2_progress_report_records_empty(inputs)
	return en_us2_progress_report_records_empty(inputs)
});
export { progress_report_records_empty as "progress-report.records_empty" }